import { useEffect } from 'react';
import { toFlagId, useFlagsService } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import { CREATE_JWM_SAMPLE_PROJECT_ERROR_FLAG_ID } from '../../common/constants.tsx';
import { useCreateJwmSampleProjectService } from '../../services/create-jwm-sample-project/main.tsx';
import messages from './messages.tsx';

export const useCreateSampleProject = () => {
	const { showFlag } = useFlagsService();
	const { error, taskId, createSampleProject, loading } = useCreateJwmSampleProjectService();

	useEffect(() => {
		if (error) {
			showFlag({
				key: toFlagId(CREATE_JWM_SAMPLE_PROJECT_ERROR_FLAG_ID),
				type: 'error',
				title: messages.errorFlagTitle,
				description: messages.errorFlagText,
				messageId: 'business-sample-project.controllers.create-jwm-sample-project.show-flag.error',
				messageType: 'transactional',
			});
		}
	}, [error, showFlag]);

	return { createSampleProject, taskId, error, loading };
};
